import { flashMessage } from '@/store/index'
import { MOONPULL_SESSION_NAME } from './plugins/moonpull/Moonpull'

function getMoonpullSession(): { tokens: any; user: any; } {
  return JSON.parse(localStorage.getItem(MOONPULL_SESSION_NAME))
}

function createMoonpullSession(tokens: any, user: any) {
  localStorage.setItem(MOONPULL_SESSION_NAME, JSON.stringify({ tokens, user }))
}

const apiUrl = process.env.VUE_APP_MOONPULL_API_ENDPOINT

export async function api(method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE', path: string, body?: any): Promise<Response> {
  try {

    // Setup headers
    const headers: any = {}

    // Handle FormData bodies that can include file uploads
    const isFormData = body instanceof FormData

    // For post bodies
    if (method !== 'GET' && ! isFormData) {
      headers['Content-Type'] = 'application/json'
    }

    // Request function for initial use and reuse in refresh if necessary
    function makeRequest() {
      const { tokens: { accessToken } } = getMoonpullSession()
      return fetch(`${apiUrl}/services${path}`, {
        method,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          ...headers,
        },
        body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
      })
    }

    // Make initial request
    let res = await makeRequest()

    // Refresh token if necessary
    if (! res.ok && res.status === 401) {

      const { user, tokens: { refreshToken } } = getMoonpullSession()
      const refreshRes = await fetch(`${apiUrl}/auth/refresh`, {
        method: 'POST',
        headers: {
          Authorization: `Refresh ${refreshToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: user.email,
        }),
      })

      if (! refreshRes.ok) {
        throw new Error('Failed to refresh token via api call')
      }

      const { error, tokens, user: refreshedUser } = await refreshRes.json()
      if (error) {
        throw new Error(error)
      }

      // Update session and retry request
      createMoonpullSession(tokens, refreshedUser)
      res = await makeRequest()
    }

    return res
  } catch (e: any) {
    console.error(`Moonpull Services API Error:`, e.message, e.stack)
    flashMessage('danger', `Unexpected API error: ${e.message}`)
  }
}
